<template>
  <div id="elpotosino" class="my-5">
    <div class="container w-75 d-flex justify-content-center align-items-start">
      <a href="https://latteexpress.com.mx">
        <img class="rounded img-fluid" style="max-height: 200px;" src="https://latteexpress.com.mx/assets/images/logo_latte.png?v=1.0.0" alt="" >
      </a>
    </div>
    <main class="main-content border-radius-lg justify-content-center mt-5 mb-5" style="position: static;">
      <div class="container-fluid justify-content-center" style="position: static;">
        <div class="row justify-content-center" style="position: static;">
          <div class="col-sm-4 col-12 d-flex justify-content-center align-items-center">
            <div style="width: 100%; display: flex;">
              <div class="w-50 h-100">
                <a href="https://latteexpress.com.mx" style="padding-right: 5px;">
                  <img src="/latteexpress_oriente.jpg" alt="" class="img-fluid border-radius-lg">
                </a>
              </div>
              <div class="w-50 h-100" style="padding-left: 5px;">
                <a href="https://latteexpress.com.mx">
                  <img src="/latteexpress_norte.jpg" alt="" class="img-fluid border-radius-lg">
                </a>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-12">
            <div class="card z-index-2 h-100">
              <div class="card-header pb-0 pt-3">
                <h3 style="color: #d4041b !important;">Latte Express</h3>
              </div>
              <div class="card-body p-3">
                <div class="justify-content-center" style="text-align: justify">
                  <small>Somos una franquicia 100% potosina ofreciendo el mejor servicio desde hace mas de 15 años. Nuestra misión es ser una cafetería reconocida a nivel nacional. Brindando el mejor café a nuestros clientes, a través de nuestro excelente servicio al cliente, con el objetivo de generar el más alto valor competitivo.</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "latteexpressinf",
  data() {
    return {
    };
  },
  props: {
  },
  created() {
        
  },
};
</script>

<style lang="scss"  scoped>
.card-header {
  position: static;
}

.main-content {
  position: static;
}

.container-fluid {
  position: static;
}

.card-carousel {
  position: static;
}

.col-sm-6 {
  position: static;
}

.col-12 {
  position: static;
}

.card {
  position: static;
}

.carousel {
  position: static;
}</style>